// =============================================================================
// PORTAL RESET PASSWORD PAGE (PortalResetPasswordPage.js)
// =============================================================================
// Lets users enter verification code and set a new password.
// Adapted from cdic-portal-react/client/src/pages/ResetPasswordPage.js
//
// KEY CHANGE: Uses initialEmail prop instead of URL query params (useSearchParams)
// =============================================================================

import React, { useState } from 'react';
import { resetPassword } from './portalApi';
import PortalLayout from './PortalLayout';
import PortalFlashMessage from './PortalFlashMessage';

function PortalResetPasswordPage({ onNavigate, initialEmail = '' }) {
  const [email, setEmail] = useState(initialEmail);
  const [confirmationCode, setConfirmationCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('info');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const data = await resetPassword(email, confirmationCode, newPassword);
      if (data.success) {
        setMessage(data.message);
        setMessageType('success');
        setTimeout(() => {
          onNavigate('login');
        }, 2000);
      } else {
        setMessage(data.message || 'Invalid or expired verification code.');
        setMessageType('error');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
      setMessageType('error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PortalLayout showLogout={false} onNavigate={onNavigate}>
      <div className="cdic-portal-form-box">
        <h2>Reset Password</h2>
        <p style={{ color: '#666', marginBottom: '20px', fontSize: '14px', lineHeight: 1.5 }}>
          Enter the verification code sent to your email along with your new password.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="cdic-portal-input-container">
            <i className="material-icons">email</i>
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="cdic-portal-input-container">
            <i className="material-icons">confirmation_number</i>
            <input
              type="text"
              placeholder="Verification Code"
              value={confirmationCode}
              onChange={(e) => setConfirmationCode(e.target.value)}
              required
            />
          </div>

          <div className="cdic-portal-input-container">
            <i className="material-icons">lock</i>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>

          <div className="cdic-portal-password-requirements">
            Password requirements:
            <ul>
              <li>At least 8 characters</li>
              <li>Include uppercase and lowercase letters</li>
              <li>Include at least one number</li>
              <li>Include at least one special character</li>
            </ul>
          </div>

          <button type="submit" disabled={isLoading}>
            {isLoading ? 'RESETTING...' : 'RESET PASSWORD'}
            {!isLoading && <i className="material-icons" style={{ marginLeft: '5px' }}>vpn_key</i>}
          </button>
        </form>

        <PortalFlashMessage
          message={message}
          type={messageType}
          onClose={() => setMessage('')}
        />

        <a
          href="#login"
          onClick={(e) => { e.preventDefault(); onNavigate('login'); }}
          style={{ marginTop: '15px', display: 'inline-block' }}
        >
          <i className="material-icons" style={{ fontSize: '14px', verticalAlign: 'middle' }}>
            arrow_back
          </i>
          {' '}Back to Login
        </a>
      </div>
    </PortalLayout>
  );
}

export default PortalResetPasswordPage;
